import Stat from '@klv/molecules/stat';
import Grid from '@klv/utils/grid';
import {
  StatsDisclaimer, StatsHeadline, StyledGrid, StyledStats,
} from './styles';
import type { IStats } from './types';

const Stats = ({
  background = 'light', disclaimer = '', stats, headline = '', ...rest
}: IStats) => (
  <StyledStats $background={background} {...rest}>
    <StyledGrid>
      {headline && <StatsHeadline $background={background} content={headline} styledAs="h3" />}
      {stats.map((stat) => (
        <Stat background={background} headline={stat.headline} subcopy={stat.subcopy} key={JSON.stringify(stat)} />
      ))}
    </StyledGrid>
    {disclaimer && (
      <Grid>
        <StatsDisclaimer
          colorVariant={background === 'dark' ? 'light' : 'dark'}
          dangerouslySetInnerHTML={{ __html: disclaimer }}
          variant="disclaimer"
        />
      </Grid>
    )}
  </StyledStats>
);

export default Stats;
